import {Map} from 'immutable';

import Participant from './Participant';
import Thread from './Thread';
import ThreadAttributeValue from './ThreadAttributeValue';
import ThreadEvent from './ThreadEvent';
import ThreadFile from './ThreadFile';
import ThreadType from './ThreadType';
import Workflow from './Workflow';
import WorkflowStatus from './WorkflowStatus';
import ParticipantParticipantAttributeValue from './ParticipantParticipantAttributeValue';
import MessageTemplate from './MessageTemplate';
import AIReply from './AIReply';

const models = {
    participants: Participant,
    threads: Thread,
    threadAttributeValues: ThreadAttributeValue,
    threadEvents: ThreadEvent,
    threadFiles: ThreadFile,
    threadTypes: ThreadType,
    workflow: Workflow,
    workflowStatuses: WorkflowStatus,
    participantParticipantAttributeValues: ParticipantParticipantAttributeValue,
    messageTemplates: MessageTemplate,
    aiReplies: AIReply
};

export function toMapOfRecords(objMap, Record) {
    return new Map(Object.keys(objMap).map((key) => [parseInt(key), new Record(objMap[key])]));
}

export function mergeEntitiesToState(state, entities) {
    return state.map((val, key) => {
        if (!Object.keys(models).includes(key)) {
            return val;
        }

        if (!Object.keys(entities).includes(key)) {
            return val;
        }

        return val.merge(toMapOfRecords(entities[key], models[key]));
    });
}

export default models;
